module.exports = __webpack_public_path__ + "img/11.494c49f2.png";